import { Button, ControlText, TextInput } from '@mint/ui';
import React, { useCallback, useState } from 'react';
import { EventOccurrenceProps } from './event-occurrence-props';
import styled from 'styled-components';

// TODO: fix this ugly hack. There's a problem with the TextInput component
//       since it is setting the additional passed properties on the input
//       itself, whereas we want to target the wrapper. For now, we're using
//       the plaintext class name.
const Wrapper = styled.div`
  border: 1px solid ${props => props.theme.palette.divider};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  margin: 1rem -0.5rem 0;
  padding: 0.5rem;
  position: relative;
  align-items: flex-start;

  .text-input {
    margin: 0.5rem 0;
    width: 100%;
  }
`;

const OccurrenceHeading = styled(ControlText)`
  font-size: 12px;
  font-weight: 700;
  display: block;
  margin-bottom: 0.75rem;
`;

const DeleteButton = styled(Button)`
  font-size: 14px;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
`;

const computeDuration = (
  startsAt?: Date | string | null,
  endsAt?: Date | string | null,
) => {
  if (startsAt && endsAt) {
    const st = new Date(startsAt);
    const et = new Date(endsAt);
    return Math.max(0, Math.round((et.getTime() - st.getTime()) / 1000));
  } else {
    return 0;
  }
};

const toLocalTime = (t: Date | string) => {
  t = new Date(t);
  const dt = new Date(t.getTime() - t.getTimezoneOffset() * 60000);
  return dt.toISOString().replace(/Z$/, '');
};

export const EventOccurrence: React.FunctionComponent<
  EventOccurrenceProps
> = props => {
  const {
    duration,
    onDeleteClick,
    onDurationChange,
    onStartsAtChange,
    startsAt,
  } = props;

  const [endsAt, setEndsAt] = useState<string | null>(
    startsAt && duration
      ? new Date(new Date(startsAt).getTime() + duration * 1000).toISOString()
      : null,
  );

  const handleStartsAtChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const st = new Date(e.target.value);
      const et = endsAt ? new Date(endsAt) : null;

      if (et && et < st) {
        setEndsAt(e.target.value);
      }

      if (onStartsAtChange) {
        onStartsAtChange(st.toISOString());
      }

      if (onDurationChange) {
        onDurationChange(computeDuration(st, et));
      }
    },
    [onDurationChange, onStartsAtChange, endsAt],
  );

  const handleEndsAtChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const et = e.target.value;
      setEndsAt(et);
      if (onDurationChange) {
        onDurationChange(computeDuration(startsAt, et));
      }
    },
    [onDurationChange, startsAt],
  );

  return (
    <Wrapper>
      <OccurrenceHeading>Event Occurrence</OccurrenceHeading>
      <DeleteButton onClick={onDeleteClick}>Delete</DeleteButton>
      <TextInput
        // defaultValue={startsAt || ' '}
        value={startsAt ? toLocalTime(startsAt) : ' '}
        label="Start Date and Time"
        onChange={handleStartsAtChange}
        type="datetime-local"
        helperText={
          <>
            Date and time the event starts <b>(required)</b>.
          </>
        }
      />
      <TextInput
        value={endsAt ? toLocalTime(endsAt) : ' '}
        onChange={handleEndsAtChange}
        label="End Date and Time"
        type="datetime-local"
        helperText="Date and time the event starts (optional)."
      />
    </Wrapper>
  );
};
